import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import '@/assets/stylus/_reset.css'
import '@/assets/stylus/_utilis.styl'
import router from './router'
import api from './api/api'
import { createHead } from '@unhead/vue'
import '@/assets/stylus/global.styl'

const app = createApp(App)
const head = createHead()
app.use(createPinia())
app.use(api)
app.use(router)
app.use(head)
router.isReady().then(() => app.mount('#app'))
